import request from "../utils/request";

export async function getBestSellerProductAndPersonal(payload) {
  var url = "Report/BestSellerProductAndPersonal?branchId=" + payload.branch.id + "&month=" + payload.month.id;
  if (payload.year) url += "&year=" + payload.year;
  return request.get(url);
}

export async function getSumOfOrders(payload) {
  return request.get("Cart/SumOfOrders?", {
    params: {
      branchId: payload.branchId ? payload.branchId : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      daysOfWeek: payload.daysOfWeek != null && payload.daysOfWeek.id !== undefined && payload.daysOfWeek.id !== null ? payload.daysOfWeek.id : null
    }
  });
}

export async function getSumOfOrdersForDealer(payload) {
  return request.get("Cart/SumOfOrdersForDealer?", {
    params: {
      branchId: payload.branchId ? payload.branchId : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      daysOfWeek: payload.daysOfWeek != null && payload.daysOfWeek.id !== undefined && payload.daysOfWeek.id !== null ? payload.daysOfWeek.id : null
    }
  });
}

export async function getExcelSumOfOrders(payload) {
  return request.get("Cart/GetExcelSumOfOrders?", {
    params: {
      branchId: payload.branchId ? payload.branchId : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null
    },
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    }
  });
}

export async function getExcelSumOfOrdersForDealer(payload) {
  let query = serialize(payload);
  return request.get("Cart/GetExcelSumOfOrdersForDealer?" + query, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    }
  });
}

export async function GetProductGiro(payload) {
  return request.get("Report/ProductReport", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      takeCount: payload.takeCount,
      categoryId: payload.category != null ? payload.category.id : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      showBranch: payload.ShowBranch
    }
  })
}

export async function GetProductGiroForDealer(payload) {
  return request.get("Report/ProductReportForDealer", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      takeCount: payload.takeCount,
      categoryId: payload.category != null ? payload.category.id : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      showBranch: payload.ShowBranch
    }
  })
}

export async function GetExcelPersonalReportAccordingTo(payload) {
  return request.get("Report/GetExcelPersonalReportAccordingTo", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      accordingTo: payload.accordingTo ? payload.accordingTo : null,
      accordingId: payload.accordingId ? payload.accordingId : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetExcelPersonalReportAccordingToForDealer(payload) {
  return request.get("Report/GetExcelPersonalReportAccordingToForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      accordingTo: payload.accordingTo ? payload.accordingTo : null,
      accordingId: payload.accordingId ? payload.accordingId : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetPersonalReportAccordingTo(payload) {
  return request.get("Report/GetPersonalReportAccordingTo", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      accordingTo: payload.accordingTo ? payload.accordingTo : null,
      accordingId: payload.accordingId ? payload.accordingId : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetBranchProductSizesReportAccordingTo(payload,branchId) {
  return request.get("Report/GetBranchProductSizesReportAccordingTo", {
    params: {
      branchId: branchId,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      accordingTo: payload.accordingTo ? payload.accordingTo : null,
      accordingId: payload.accordingId ? payload.accordingId : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetBranchProductSizesReportAccordingToForProduct(payload,branchId) {
  return request.get("Report/GetBranchProductSizesReportAccordingToForProduct", {
    params: {
      branchId: branchId,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      accordingTo: payload.accordingTo ? payload.accordingTo : null,
      accordingId: payload.accordingId ? payload.accordingId : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetPersonalReportAccordingToForDealer(payload) {
  return request.get("Report/GetPersonalReportAccordingToForDealer", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      accordingTo: payload.accordingTo ? payload.accordingTo : null,
      accordingId: payload.accordingId ? payload.accordingId : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetProductGiroExcel(payload) {
  return request.get("Report/GetProductExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      takeCount: payload.takeCount,
      categoryId: payload.category != null ? payload.category.id : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      showBranch: payload.ShowBranch
    }
  })
}
export async function GetProductGiroExcelForDealer(payload) {
  return request.get("Report/GetProductExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      takeCount: payload.takeCount,
      categoryId: payload.category != null ? payload.category.id : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      showBranch: payload.ShowBranch
    }
  })
}
export async function GetRawMaterialExcel() {
  return request.get("RawMaterial/RawMaterialExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    }
  })
}
export async function GetRawMaterialExcelWithKdv() {
  return request.get("RawMaterial/RawMaterialExcelWithKdv", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    }
  })
}
export async function GetAllProductsPriceExcel(payload) {
  return request.get("Product/GetAllProductsPriceExcel", {
    params: {
      branchId: payload && payload.branch ? payload.branch.id : null
    },
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    }
  })
}
export async function GetCategoryGiro(payload) {
  return request.get("Report/CategoryReport", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      takeCount: payload.takeCount,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      showBranch: payload.ShowBranch
    }
  })
}

export async function GetCategoryGiroForDealer(payload) {
  return request.get("Report/CategoryReportForDealer", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      takeCount: payload.takeCount,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      showBranch: payload.ShowBranch
    }
  })
}

export async function GetCategoryGiroExcel(payload) {
  return request.get("Report/GetCategoryReportExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      takeCount: payload.takeCount,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      showBranch: payload.ShowBranch
    }
  })
}

export async function GetCategoryGiroExcelForDealer(payload) {
  return request.get("Report/GetCategoryReportExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      takeCount: payload.takeCount,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null,
      showBranch: payload.ShowBranch
    }
  })
}

export async function GetPaymentReport(payload) {
  return request.get("Report/PaymentReport", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetPaymentReportForDealer(payload) {
  return request.get("Report/PaymentReportForDealer", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetRawMaterialConsumptionSum(payload) {
  return request.get("Report/RawMaterialConsumptionSum", {
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy,
      variantId: payload.variant ? payload.variant.id : null,
      rawMaterialCategoryId: payload.rawMaterialCategory ? payload.rawMaterialCategory.id : null,
    }
  })
}

export async function GetRawMaterialConsumptionSumForDealer(payload) {
  return request.get("Report/RawMaterialConsumptionSumForDealer", {
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy,
      variantId: payload.variant ? payload.variant.id : null,
      rawMaterialCategoryId: payload.rawMaterialCategory ? payload.rawMaterialCategory.id : null,
    }
  })
}

export async function GetRawMaterialConsumptionSumExcel(payload) {
  return request.get("Report/RawMaterialConsumptionSumsExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy,
      variantId: payload.variant ? payload.variant.id : null,
      rawMaterialCategoryId: payload.rawMaterialCategory ? payload.rawMaterialCategory.id : null,
    }
  })
}

export async function GetRawMaterialConsumptionSumExcelForDealer(payload) {
  return request.get("Report/RawMaterialConsumptionSumsExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy,
      variantId: payload.variant ? payload.variant.id : null,
      rawMaterialCategoryId: payload.rawMaterialCategory ? payload.rawMaterialCategory.id : null,
    }
  })
}

export async function GetRawMaterialConsumptionSumForLoss(payload) {
  return request.get("Report/RawMaterialConsumptionSumForLoss", {
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy,
      variantId: payload.variant ? payload.variant.id : null,
      rawMaterialCategoryId: payload.rawMaterialCategory ? payload.rawMaterialCategory.id : null,
    }
  })
}

export async function GetRawMaterialConsumptionSumForLossForDealer(payload) {
  return request.get("Report/RawMaterialConsumptionSumForLossForDealer", {
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy,
      variantId: payload.variant ? payload.variant.id : null,
      rawMaterialCategoryId: payload.rawMaterialCategory ? payload.rawMaterialCategory.id : null,
    }
  })
}

export async function GetRawMaterialConsumptionSumsExcelForLoss(payload) {
  return request.get("Report/RawMaterialConsumptionSumsExcelForLoss", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy,
      variantId: payload.variant ? payload.variant.id : null,
      rawMaterialCategoryId: payload.rawMaterialCategory ? payload.rawMaterialCategory.id : null,
    }
  })
}

export async function GetRawMaterialConsumptionSumsExcelForLossForDealer(payload) {
  return request.get("Report/RawMaterialConsumptionSumsExcelForLossForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy,
      variantId: payload.variant ? payload.variant.id : null,
      rawMaterialCategoryId: payload.rawMaterialCategory ? payload.rawMaterialCategory.id : null,
    }
  })
}

export async function GetWalletTransactionExcel(payload) {
  return request.get("Wallet/transactions-excel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      startDay: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDay: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null
    }
  })
}

export async function GetWalletTransaction(payload) {
  return request.get("Wallet/transactions", {
    params: {
      startDay: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDay: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      branchId: payload.branch ? payload.branch.id : null
    }
  })
}

export async function GetRawMaterialConsumptionByBranchExcel(payload, rawMaterialId) {
  return request.get("Report/RawMaterialConsumptionByBranchExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      rawMaterialId: rawMaterialId,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy
    }
  })
}

export async function GetRawMaterialConsumptionByBranchExcelForDealer(payload, rawMaterialId) {
  return request.get("Report/RawMaterialConsumptionByBranchExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      rawMaterialId: rawMaterialId,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy
    }
  })
}

export async function GetRawMaterialConsumptionByBranch(payload, rawMaterialId) {
  return request.get("Report/RawMaterialConsumptionByBranch", {
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      rawMaterialId: rawMaterialId,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy
    }
  })
}

export async function GetRawMaterialConsumptionByBranchForDealer(payload, rawMaterialId) {
  return request.get("Report/RawMaterialConsumptionByBranchForDealer", {
    params: {
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      rawMaterialId: rawMaterialId,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      sortDirection: payload.sortDirection ? payload.sortDirection.id : null,
      takeCount: payload.takeCount,
      sortBy: payload.sortBy
    }
  })
}

export async function GetTotalsOfSales(payload) {
  return request.get("Report/TotalsOfSales", {
    params: {
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      branchId: payload.branch ? payload.branch.id : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetTotalsOfSalesForDealer(payload) {
  return request.get("Report/TotalsOfSalesForDealer", {
    params: {
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      branchId: payload.branch ? payload.branch.id : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetBranchMoodTransactions(payload, rawPayload) {
  return request.get("Report/BranchMoodReport", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      productId: rawPayload.product ? rawPayload.product.id : null,
      customerId: rawPayload.customer ? rawPayload.customer.id : null,
      branchId: rawPayload.branch ? rawPayload.branch.id : null,
      type: rawPayload.type,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetBranchMoodTransactionsExcel(payload, rawPayload) {
  return request.get("Report/BranchMoodReportExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      productId: rawPayload.product ? rawPayload.product.id : null,
      customerId: rawPayload.customer ? rawPayload.customer.id : null,
      branchId: rawPayload.branch ? rawPayload.branch.id : null,
      type: rawPayload.type,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetGroupedBranchMoodTransactions(payload) {
  var branchid =payload.branch ? payload.branch.id : null;
  if(branchid==null && payload.branchId!=null){
    branchid=payload.branchId;
  }
  return request.get("Report/GroupedBranchMoodReport", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      productId: payload.product ? payload.product.id : null,
      branchId: branchid,
      customerId: (payload.customerEmail && payload.customerEmail.id) ? payload.customerEmail.id : ((payload.customerPhoneNumber && payload.customerPhoneNumber.id) ? payload.customerPhoneNumber.id : null),
      customerEmail: typeof payload.customerEmail === 'string' ? payload.customerEmail : (payload.customerEmail ? payload.customerEmail.name : null),
      customerPhoneNumber: typeof payload.customerPhoneNumber === 'string' ? payload.customerPhoneNumber : (payload.customerPhoneNumber ? payload.customerPhoneNumber.name : null),
      type: payload.type ? payload.type.id : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetGroupedBranchMoodTransactionsExcel(payload) {
  return request.get("Report/GroupedBranchMoodReportExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      productId: payload.product ? payload.product.id : null,
      branchId: payload.branch ? payload.branch.id : null,
      customerId: (payload.customerEmail && payload.customerEmail.id) ? payload.customerEmail.id : ((payload.customerPhoneNumber && payload.customerPhoneNumber.id) ? payload.customerPhoneNumber.id : null),
      customerEmail: typeof payload.customerEmail === 'string' ? payload.customerEmail : (payload.customerEmail ? payload.customerEmail.name : null),
      customerPhoneNumber: typeof payload.customerPhoneNumber === 'string' ? payload.customerPhoneNumber : (payload.customerPhoneNumber ? payload.customerPhoneNumber.name : null),
      type: payload.type ? payload.type.id : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetMoodLedgerReport(payload) {
  var branchid = payload.branch ? payload.branch.id : null;
  if (branchid == null && payload.branchId != null) {
    branchid = payload.branchId;
  }
  return request.get("Report/MoodLedger", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      branchId: branchid,
      customerPhoneNumber: typeof payload.customerPhoneNumber === 'string' ? payload.customerPhoneNumber : (payload.customerPhoneNumber ? payload.customerPhoneNumber.name : null)
    }
  })
}

export async function GetBranchBalancesNewReport(payload) {
  return request.get("Report/BranchBalancesNew", {
    params: {
      code: payload.branchCode,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      cityId: payload.city != null ? payload.city.id : null,
      stateId: payload.state != null ? payload.state.id : null,
      email: payload.branchEmail,
      phoneNumber: payload.branchPhoneNumber,
      address: payload.branchAddress,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}

export async function GetBranchMoodLedgerDetail(branchId) {
  return request.get("Report/BranchMoodLedgerDetail", {
    params: { branchId }
  });
}

export async function GetMoodLedgerReportExcel(payload) {
  var branchid = payload.branch ? payload.branch.id : null;
  if (branchid == null && payload.branchId != null) {
    branchid = payload.branchId;
  }
  return request.get("Report/MoodLedgerExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      branchId: branchid,
      customerPhoneNumber: typeof payload.customerPhoneNumber === 'string' ? payload.customerPhoneNumber : (payload.customerPhoneNumber ? payload.customerPhoneNumber.name : null)
    }
  });
}

export async function GetBranchBalancesNewExcel(payload) {
  return request.get("Report/BranchBalancesNewExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      code: payload.branchCode,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      cityId: payload.city != null ? payload.city.id : null,
      stateId: payload.state != null ? payload.state.id : null,
      email: payload.branchEmail,
      phoneNumber: payload.branchPhoneNumber,
      address: payload.branchAddress,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}

export async function GetBranchBalances(payload) {
  return request.get("Report/BranchBalances", {
    params: {
      code: payload.branchCode,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      cityId: payload.city != null ? payload.city.id : null,
      stateId: payload.state != null ? payload.state.id : null,
      email: payload.branchEmail,
      phoneNumber: payload.branchPhoneNumber,
      address: payload.branchAddress,
      startTime: null,
      endTime: null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}

export async function GetBranchBalancesExcel(payload) {
  return request.get("Report/BranchBalancesExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      code: payload.branchCode,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      cityId: payload.city != null ? payload.city.id : null,
      stateId: payload.state != null ? payload.state.id : null,
      email: payload.branchEmail,
      phoneNumber: payload.branchPhoneNumber,
      address: payload.branchAddress,
      startTime: null,
      endTime: null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}

export async function GetBranchGiro(payload) {
  return request.get("Report/BranchSalesReport", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      takeCount: payload.takeCount,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetBranchGiroForDealer(payload) {
  return request.get("Report/BranchSalesReportForDealer", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      takeCount: payload.takeCount,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetStockOrdersForDashboard(payload) {
  return request.get("Report/StockOrderForDashboard", {
    params: {
      branchId: payload
    }
  })
}

export async function GetTargetsForDashboard(payload) {
  return request.get("Report/TargetsForDashboard", {
    params: {
      branchId: payload
    }
  })
}

export async function GetBranchPersonalGiro(payload) {
  return request.get("Report/UserSalesReport", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      byProp: payload.reportByProp ? payload.reportByProp.id : null,
      takeCount: payload.takeCount,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetBranchOrPersonalGiroExcel(payload) {
  return request.get("Report/GetBranchOrPersonalExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      sortDirection: payload.direction ? payload.direction.id : null,
      byProp: payload.dashboardByProp ? payload.reportByProp.id : null,
      takeCount: payload.takeCount,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetGiroByTime(payload) {
  return request.get("Report/TimeReport", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      hourPeriod: payload.hourPeriod ? parseInt(payload.hourPeriod) : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetGiroByTimeForDealer(payload) {
  return request.get("Report/TimeReportForDealer", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      hourPeriod: payload.hourPeriod ? parseInt(payload.hourPeriod) : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetGiroByTimeExcel(payload) {
  return request.get("Report/GetByTimeExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      hourPeriod: payload.hourPeriod ? parseInt(payload.hourPeriod) : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetGiroByTimeExcelForDealer(payload) {
  return request.get("Report/GetByTimeExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      hourPeriod: payload.hourPeriod ? parseInt(payload.hourPeriod) : null,
      daysOfWeek: payload.daysOfWeek ? payload.daysOfWeek.id : null
    }
  })
}

export async function GetGiroByDate(payload) {
  return request.get("Report/DateReport", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function DateReportWithDayExcel(payload) {
  return request.get("Report/date-report-daily-excel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function DateReportWithDayExcelForDealer(payload) {
  return request.get("Report/date-report-daily-excel-for-dealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function GetGiroByDateForDealer(payload) {
  return request.get("Report/DateReportForDealer", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function GetGiroByDateExcel(payload) {
  return request.get("Report/GetByDateExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function GetGiroByDateExcelForDealer(payload) {
  return request.get("Report/GetByDateExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
      startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function getComparativeBranchReport(payload, sortDirection, sortBy, selectedBranches) {
  return request.post("Report/BranchComparativeReport", {
    sortBy: sortBy,
    isSharded: payload.isSharded,
    sortDirection: sortDirection,
    accordings: payload.accordings,
    branches: selectedBranches,
    accordingTo: payload.accordingTo ? payload.accordingTo.id : null,
    timeRange: payload.defaultTimeRange ? payload.defaultTimeRange.id : null,
    startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate : null,
    endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate : null,
    startTime: payload.timeRange && payload.timeRange.startTime ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
    endTime: payload.timeRange && payload.timeRange.endTime ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
  })
}

export async function getSumOfOrdersLive() {
  return request.get("Cart/SumOfOrdersLive");
}

export async function GetReferralDetail(customerId) {
  return request.get("Report/ReferralDetail?customerId=" + customerId);
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}
